export const TOOL_NAME = 'pdfme (https://github.com/hand-dot/pdfme)';
//# sourceMappingURL=constants.js.map